<template>
  <section class="welcome-card">
    <div class="welcome-card-inner">
      <div class="welcome-logo-block">
        <div class="welcome-logo-wrap">
          <div class="welcome-logo-glow"></div>
          <img alt="SUPERDOC Brand Logo" class="welcome-logo" src="@public/assets/images/ic_superdoc_ava.svg" />
        </div>
        <p class="welcome-brand">SUPERDOC</p>
      </div>
      <div class="welcome-title markdown-content" v-html="markdownRenderer(message)"></div>
      <!-- <p class="welcome-subtitle">{{ subtitle }}</p> -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'SuperDocWelcome',
  props: {
    message: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    markdownRenderer: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped>
.welcome-card {
  position: relative;
  margin: 0 auto 16px;
  width: fit-content;
  max-width: min(92vw, 56rem);
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #dbeafe;
  background: linear-gradient(90deg, rgba(239, 246, 255, 0.8), #fff, rgba(239, 246, 255, 0.5));
  padding: 14px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.welcome-card-inner {
  position: relative;
  margin: 0 auto;
  width: fit-content;
  max-width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.welcome-logo-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.welcome-logo-wrap {
  position: relative;
  width: 64px;
  height: 64px;
}

.welcome-logo-glow {
  position: absolute;
  inset: 0;
  border-radius: 9999px;
  background: rgba(59, 130, 246, 0.15);
  filter: blur(12px);
}

.welcome-logo {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.welcome-brand {
  margin: 0;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(59, 130, 246, 0.8);
}

.welcome-title {
  max-width: 100%;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: #0f172a;
  white-space: pre-line;
  word-break: break-word;
}

.welcome-title :deep(p) {
  margin: 0;
}

.welcome-subtitle {
  margin: 0 auto;
  max-width: 28rem;
  font-size: 12px;
  line-height: 1.55;
  color: #64748b;
}
</style>
